import * as React from 'react';
import TimeStampPanel from '../panels/timestampPanel';
import { Message } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

interface ManifestItem {
    timestamp: number;
    content: string;
}

class State {
    data: Array<ManifestItem>;
    ts?: number;
    selected?: number;
    firstTime?: boolean;
}

interface Props {
    refresh?: number;
    streamid: number;
    streamName: string;
    url: string;
    timerange?: string;
    raw?: boolean;
    parse?: boolean;
    summary?: boolean;
    vod?: boolean;
    header?: boolean;
}

export default class MIMEHeaderView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        timerange: 'all',
        summary: false,
        refresh: 10000,
        raw: true,
        parse: true,
        vod: false,
        header: true
    };

    private updateTimer: number;

    componentWillUnmount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);
    }

    componentWillMount() {
        this.setState({
            ts: 0,
            selected: 0,
            firstTime: true
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    content() {
        // tslint:disable-next-line:no-empty
        if (this.state === null || this.state.data === null || this.state.selected === null || this.state.selected === undefined || this.state.data === undefined) {
        } else {
            if (this.state.data[this.state.selected] && this.state.data[this.state.selected].content) {
                return (
                    <pre>{this.state.data[this.state.selected].content}</pre>
                );
            }
        }
        if (this.props.vod === true) {
            return 'No data to display. NOTE: Records are purged 5 minutes after the stream test completes. These details may have already been purged.';
        } else {
            return 'No data to display.';
        }
    }

    render() {
        return (
            <div className="view-content" id="headers">
                {(this.props.header === true) ?
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">MIME Headers</div>
                        </div>
                    </div>
                </div> : ''}
                {(this.props.header === true) ?
                <div className="manifestWindowTBar" title={this.props.url}>
                    <h4>{this.props.streamName}</h4>
                    <h5>{this.props.url}</h5>
                </div> : ''}
                <div className="dividedArea">
                    <div className="fixedWidth">
                        <TimeStampPanel
                            ref="assets"
                            className="timestamp-panel"
                            header="Timestamp"
                            activeTs={this.state.ts}
                            data={(this.state && this.state.data) ? this.state.data : []}
                            onClick={(ts: number, i: number) => {
                                this.setState({
                                    ts: ts,
                                    selected: i
                                });
                            }}
                        />
                    </div>
                    <Message className="calculatedWidth-message">
                        {this.content()}
                    </Message>
                </div>
            </div>
        );
    }

    scheduleNextUpdate(ms ?: number) {
        if (ms === undefined)
            ms = this.props.refresh;
        this.updateTimer = setTimeout(() => this.fetchData(), ms);
    }

    fetchData() {
        let _this = this;
        const { streamid, timerange, raw, parse, vod } = this.props;
        let url = 'http://default/api/'
            + (vod ? 'vod/' : 'stream/')
            + streamid + '/metadata/headers';
        axios.post(url, {
            streams: streamid,
            timerange,
            raw,
            parse
        },         {
            headers: {
                'x-orderby': 'order headers.items by timestamp desc'
            }
        })
            .then(function (response: AxiosResponse) {
                if ( response.data !== undefined  ) {
                    if (response.data.headers !== undefined) {
                        const index = response.data.headers.items.findIndex(function(element: any) {
                            return element.timestamp === _this.state.ts;
                        });

                        if (index === -1) {
                            if (_this.state.firstTime) {
                                _this.setState ( {
                                    firstTime: false
                                });
                            }
                            _this.setState ( {
                                ts: response.data.headers.items[0].timestamp,
                                data: response.data.headers.items,
                                selected: 0
                            });
                        } else {
                            _this.setState({
                                data: response.data.headers.items,
                                selected: index
                            });
                        }
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of mime headers, got ', response.data);
                } else {
                    // tslint:disable-next-line:no-console
                    console.log(' mime headers request error: ', response.data);
                }
                _this.scheduleNextUpdate();
            })
            .catch(function (error: AxiosRequestConfig) {
                _this.scheduleNextUpdate();
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/mimeHeader.tsx